import styled from '@emotion/styled';
import React from 'react';
import { MarketingImage } from '../../../../components/MarketingPagesShared/MarketingImage';
import { MarketingVideo } from '../../../../components/MarketingPagesShared/MarketingVideo';
import { SwitchPageSection } from '../../styles';
import {
  BREAKPOINT_SMALL,
  MarketingBoldAnchor,
} from '../../../../components/MarketingPagesShared/styles';

export function SwitchVideoSection() {
  const width = 700;
  const height = 393;
  return (
    <SwitchPageVideoContainer>
      <SwitchPageVideoWrapper>
        <MarketingVideo
          width={width}
          height={height}
          title="How to switch your podcast to Anchor"
          youTubeVideoId="sg9wTQlt4vs"
        >
          <MarketingImage
            width={width}
            height={height}
            alt="A dimmed video thumbnail for the video: How to switch your podcast to Anchor"
            imagePath="switch/video-thumbnail"
          />
        </MarketingVideo>
        <SwitchPageVideoAnchor
          href="https://help.anchor.fm/hc/en-us/articles/360023100411-Switching-your-podcast-to-Anchor"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more about how switching works.
        </SwitchPageVideoAnchor>
      </SwitchPageVideoWrapper>
    </SwitchPageVideoContainer>
  );
}

const SwitchPageVideoAnchor = styled(MarketingBoldAnchor)`
  display: inline-block;
  margin-top: 10px;
`;

const SwitchPageVideoWrapper = styled.div`
  width: 70%;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: 100%;
  }
`;

const SwitchPageVideoContainer = styled(SwitchPageSection)`
  display: flex;
  justify-content: center;
  margin-bottom: 200px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-bottom: 125px;
  }
`;
